import * as types from './actionTypes';


export const getFile = (file_type, level) =>{
  return{
    type: types.GET_BALANCE_SHEET_REQUEST_FILE,
    level,
    file_type
  }
};

export const get = () =>{
  return{
    type: types.GET_BALANCE_SHEET_REQUEST,
    payLoad: {loading: true}
  }
};

export const getSuccess = data => {
  return {
    type: types.GET_BALANCE_SHEET_SUCCESS,
    payLoad: {data:data.data, meta:{cost_sum: data.cost_sum, earning_sum: data.earning_sum}, loading: false}
  };
};
export const getFailure = () => {
  return {
    type: types.GET_BALANCE_SHEET_FAILURE,
    payLoad: {loading: false}
  };
};

export const getDetail1 = (id, is_balance_sheet) =>{
  return{
    type: types.GET_DETAIL1_BALANCE_SHEET_REQUEST,
    id,
    is_balance_sheet,
    payLoad: {loading: true}
  }
};

export const getDetail1Success = data => {
  return {
    type: types.GET_DETAIL1_BALANCE_SHEET_SUCCESS,
    payLoad: {data:data, loading: false}
  };
};
export const getDetail1Failure = () => {
  return {
    type: types.GET_DETAIL1_BALANCE_SHEET_FAILURE,
    payLoad: {loading: false}
  };
};

export const getDetail2 = (id, parentId,  pageNumber, is_balance_sheet) =>{
  return{
    type: types.GET_DETAIL2_BALANCE_SHEET_REQUEST,
    parentId,
    id,
    pageNumber,
    is_balance_sheet,
    payLoad: {loading: true}
  }
};

export const getDetail2Success = data => {
  return {
    type: types.GET_DETAIL2_BALANCE_SHEET_SUCCESS,
    payLoad: {data:data, loading: false}
  };
};
export const getDetail2Failure = () => {
  return {
    type: types.GET_DETAIL2_BALANCE_SHEET_FAILURE,
    payLoad: {loading: false}
  };
};

export const remove = (id, type, pageId, parentId, pageNumber, is_balance_sheet) => {
  return {
    type: types.API_REMOVE_BALANCE_SHEET_DETAIL2_REQUEST,
    id: id,
    _type: type,
    pageId,
    parentId,
    pageNumber,
    is_balance_sheet
  }
};

export const removeSuccess = (data) =>{
  return {
    type: types.API_REMOVE_BALANCE_SHEET_DETAIL2_SUCCESS,
    payLoad: { data, loading: false }
  }
};

export const removeFailure = () => {
  return {
    type: types.API_REMOVE_BALANCE_SHEET_DETAIL2_FAILURE,
    payLoad: { loading: false }
  };
};